<template>
        <v-card flat :class="$style.failure_feed">
            <v-card-title class="justify-center pt-0">
                <SvgIcon :src="getSource" :class=""/>            
                <!-- <img :src="VivomapLogo"/> -->
            </v-card-title>
            
            <v-card-text class="title">
                <!-- <p><str index="message > system_unexpected_error" /></p> -->
                <p><str :index="getMessage" /></p>
            </v-card-text>
            
            <v-card-actions v-if="actionButtonState==='show'" class="justify-center">       
                <v-btn @click="$emit('doTargetAction',targetAction)" color="#1c94ec" dark>
                    <str index="button > try_again"/>
                </v-btn>
            </v-card-actions>            
        </v-card>    
</template>

<script>
import SvgIcon from '@/components/svg/svg_icon.vue';
import ErrorIcon from '@/assets/images/icons/error.svg';

export default {
    name: "SystemFailureFeed",
    components: {
        SvgIcon,
        ErrorIcon
    },
    props: {
        targetAction: {
            type: String
        },
        feedDetails: {
            type: String
        },
        actionButtonState: {
            type: String
        }
    },     
    data: function(){
        return {
            feedDetailsMessageMap: {
                "void": "message > void placeholder",
                "failure :: 0::account already exists": "message > account_exists"
            }
        }
    },

    methods: {

    },
    computed: {
        getSource: function(){
            return ErrorIcon;
        },
        getMessage: function(){
            return this.feedDetailsMessageMap[this.feedDetails] !== undefined ? this.feedDetailsMessageMap[this.feedDetails] : this.feedDetailsMessageMap["void"];
        }
    },
    watch: {

    }
}
</script>

<style module>
.failure_feed {
    background: transparent !important;
}
.failure_feed p {
    font-size: 17px;
    width: 90%;
    margin: 2% auto 0;
}
</style>

<style>

</style>